<template>
    <div
        class="tw-my-4 tw-flex tw-justify-between tw-gap-2"
        :class="isAsiInquiry ? 'tw-items-center' : 'md:tw-w-3/4 tw-mx-auto'"
    >
        <div
            class="tw-w-full"
            :class="isAsiInquiry ? 'tw-text-left tw-self-center' : 'tw-text-center'"
            v-html="isAsiInquiry ? asiLabel : label"
        />
        <div
            class="controls tw-cursor-pointer tw-select-none tw-w-1/2"
            :class="{ 'tw-justify-end': isAsiInquiry }"
        >
            <button
                @click="decrease"
                class="button"
                :class="{ 'button--asi': isAsiInquiry, 'is-min': isAsiInquiry && value <= min }"
            >
                <span>-</span>
            </button>
            <input
                class="tw-w-full"
                :class="{ 'input--asi': isAsiInquiry }"
                :name="name"
                disabled
                maxlength="2"
                size="2"
                :min="min"
                type="number"
                v-model.number="model"
            />
            <button
                @click="increase"
                class="button"
                :class="{ 'button--asi': isAsiInquiry }"
            >
                <span>+</span>
            </button>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";

    export default {
        props: {
            name: {
                type: String,
                required: true,
            },
            min: {
                type: Number,
                required: true
            },
            value: {
                type: Number,
                required: true,
            },
            label: {
                type: String,
                required: true
            }
        },
        methods: {
            decrease() {
                if (this.value <= this.min) {
                } else {
                    this.$emit('input', this.value - 1);
                }
            },
            increase() {
                this.$emit('input', this.value + 1);
            },
        },
        computed: {
            ...mapGetters({
                isAsiInquiry: 'tour/isAsiInquiry',
            }),
            // ASI rebrand label: bold title + inline muted age hint, instead of
            // the WDT stacked parenthetical ("Erwachsene<br>(ab 13 Jahren)").
            asiLabel() {
                const [titleRaw, ...rest] = String(this.label).split(/<br\s*\/?>/i);
                const title = (titleRaw || '').trim();
                const age = rest.join(' ').replace(/^\s*\(|\)\s*$/g, '').trim();
                return `<span style="font-weight:600">${title}</span>`
                    + (age ? `<span style="color:#979797;font-weight:400;font-size:0.9em;margin-left:8px">${age}</span>` : '');
            },
            model: {
                get: function () {
                    return this.value;
                },
                set: function (newVal) {
                    this.$emit('input', newVal);
                },
            }
        },
    }
</script>

<style scoped>
    .controls {
        display: flex;
        align-items: center;
    }

    .button {
        font-size: 20px;
        color: var(--number-input-glyph-color, rgb(var(--color-red-700-rgb, 171 71 74)));
        border: 2px solid var(--brand-primary);
        border-radius: 100%;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: lighter;
    }

    /* ASI rebrand: rounded-square +/- buttons with a thin neutral border.
       Active = near-black; a control greys out (disabled look) at its min. */
    .button--asi {
        border-radius: 8px;
        border: 1.5px solid #121212;
        color: #121212;
    }
    .button--asi.is-min {
        border-color: #D9D9D9;
        color: #979797;
        cursor: default;
    }
    .button--asi span {
        line-height: 1;
    }


    input[type=number] {
        -moz-appearance: textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input {
        display: flex;
        align-items: center;
        border: none;
        height: 40px;
        width: 40px;
        font-size: 20px;
        text-align: center;
        font-weight: lighter;
    }
    input:disabled {
        opacity: 1;
        background: transparent;
    }

    /* ASI rebrand: the count reads as a muted grey value, matching the mock. */
    .input--asi {
        color: #565656;
        font-weight: 400;
    }
</style>